module.exports = __webpack_public_path__ + "static/media/FL_BNoble_pt.8465fdff.png";